module.exports = __webpack_public_path__ + "img/icon-lightning.a87ac7ad.png";